<script>
import { insTypeIcon, insTypeName, insTypeOrders } from 'base/config'
import Stat from 'common/js/stat'
import Scroll from 'base/scroll/scroll'

const PERCENTAGE = 710 / 750
const SHOW_ICON_PADDING = 20
const SHOW_ICON_NUMBER = 5.5
// 需要显示每日保费的计划书标签序号
const PB_DAILY_TAG = [1, 2, 4, 10]

export default {
  name: 'CategoryIcons',
  components: {
    Scroll
  },
  mixins: [Stat],
  props: {
    propCategoryList: {
      type: Array,
      default: function () {
        return []
      }
    },
    propCategorySort: {
      type: String
    },
    propCategorySortList: {
      type: Array
    },
    totalBaof: {
      type: Number,
      default: 0
    },
    tagList: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      categoryList: this._initInsType(this.propCategoryList),
      categoryWidth: 0
    }
  },
  computed: {
    styleObject () {
      let width
      if (this.categoryList.length > SHOW_ICON_NUMBER) {
        width = Math.round(
          (PERCENTAGE *
            (window.innerWidth ||
              document.documentElement.clientWidth ||
              document.body.clientWidth) -
            SHOW_ICON_PADDING) /
            SHOW_ICON_NUMBER
        )
        this.categoryWidth = `${width * this.categoryList.length}px`
        return {
          width: width + 'px'
        }
      }
      return {}
    },
    dailyVisible () {
      const { tagList, totalBaof } = this
      let flag = false
      if (!Array.isArray(tagList)) return
      for (let i = 0, j = PB_DAILY_TAG.length; i < j; i++) {
        if (tagList.indexOf(PB_DAILY_TAG[i]) > -1) {
          flag = true
          break
        }
      }

      return flag && totalBaof && totalBaof <= 10000
    }
  },
  watch: {
    propCategoryList: function (newList) {
      this.categoryList = this._initInsType(newList)
    }
  },
  created () {},
  mounted () {},
  methods: {
    _initInsType (insTypeList) {
      const { propCategorySort, propCategorySortList } = this
      let tempCategoryList = []
      const categorySort = propCategorySort || 'normal'
      const insTypeOrder = insTypeOrders[categorySort]
      const sortList =
        Array.isArray(propCategorySortList) && propCategorySortList.length
          ? propCategorySortList
          : insTypeOrder
      for (var i = 0, j = insTypeList.length; i < j; i++) {
        const index = sortList[i] - 1
        if (!insTypeList[i]) continue
        const iconName = insTypeIcon[index] || 'lifetime_line'
        const icon = `icon-${iconName}`
        const name = insTypeName[index]
        tempCategoryList.push({
          icon,
          name
        })
      }
      return tempCategoryList
    }
  }
}
</script>

<template>
  <div v-if="categoryList && categoryList.length >= 3" class="category-wrap">
    <template v-if="categoryList.length <= 5">
      <div v-if="dailyVisible" class="daily-pay">
        平均每天约{{ (totalBaof / 365).toFixed(2) }}元，拥有一份安心保障
      </div>
      <ul
        class="category-list"
        :class="{ 'category-flex': categoryList.length <= 5 }"
      >
        <li
          v-for="(item, index) in categoryList"
          :key="index"
          class="item"
          :style="styleObject"
          @click="submit($event, 'bzgl', { name: item.name })"
        >
          <div class="icon-wrap after-bdr">
            <i class="iconfont" :class="item.icon" />
          </div>
          <p>{{ item.name }}</p>
        </li>
      </ul>
    </template>
    <template v-else>
      <div v-if="dailyVisible" class="daily-pay">
        平均每天约{{ (totalBaof / 365).toFixed(2) }}元，拥有一份安心保障
      </div>
      <scroll
        ref="list"
        class="category-container"
        :listen-scroll="true"
        :pullup="true"
        :scroll-x="true"
        :event-passthrough="'vertical'"
        :data="{ str: categoryList }"
      >
        <ul
          class="category-list"
          :class="{ 'category-flex': categoryList.length <= 5 }"
          :style="{ width: categoryWidth }"
        >
          <li
            v-for="(item, index) in categoryList"
            :key="index"
            class="item"
            :style="styleObject"
            @click="submit($event, 'bzgl', { name: item.name })"
          >
            <div class="icon-wrap after-bdr">
              <i class="iconfont" :class="item.icon" />
            </div>
            <p>{{ item.name }}</p>
          </li>
        </ul>
      </scroll>
    </template>
  </div>
</template>

<style>
@import 'variable';

.category-wrap {
  position: relative;
  @apply --widthcenter;
  margin-bottom: 10px;
  padding: 15px 10px;
  background-color: var(--white-color);
  border-radius: 4px;
}

.daily-pay {
  margin-bottom: 15px;
  text-align: center;
  font-size: 15px;
}

.category-container {
  overflow: hidden;
}

.category-list {
  white-space: nowrap;
  &.category-flex {
    display: flex;
    .item {
      display: block;
      flex: 1;
    }
  }
  .item {
    display: inline-block;
    padding: 0 7px;
    text-align: center;
    .icon-wrap {
      position: relative;
      width: 40px;
      max-width: 100%;
      height: 40px;
      margin: 0 auto 5px;
      text-align: center;
      &:after {
        border-radius: 100%;
      }
    }
    i {
      font-size: 24px;
      @apply --center;
    }
    p {
      font-size: 12px;
      color: var(--thre-color);
    }
  }
}

@media screen and (device-width <= 320px) {
  .category-list .item {
    padding: 0 2px;
    .icon-wrap {
      width: 35px;
      height: 35px;
    }
    p {
      transform: scale(0.8);
    }
  }
}
</style>